import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card p-4 text-center"
}
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "row pb-3" }
const _hoisted_6 = { class: "col-md-4 offset-md-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = {
  key: 1,
  class: "card p-4 text-center"
}
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger p-1"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.updateMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[14] || (_cache[14] = _createElementVNode("p", null, "You must verify your mobile number to proceed.", -1)),
          _createElementVNode("p", _hoisted_2, [
            _cache[7] || (_cache[7] = _createTextVNode("A verification code has been sent to ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.mobileNumber), 1),
            _cache[8] || (_cache[8] = _createTextVNode("."))
          ]),
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("small", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Wrong number? ")),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link p-0",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editMobile && _ctx.editMobile(...args)))
              }, "Edit Mobile Number")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "verification-code_1" }, "Enter one-time code", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control text-center ver-code-input",
                  type: "text",
                  maxlength: "6",
                  name: "ver_code",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.code]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.verifyMobile && _ctx.verifyMobile(...args))),
                disabled: _ctx.code.length !== 6
              }, _cache[10] || (_cache[10] = [
                _createTextVNode("Submit Code "),
                _createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
              ]), 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("small", null, [
              _cache[13] || (_cache[13] = _createTextVNode("Didn't receive a code? ")),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link p-0",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generateCode && _ctx.generateCode(...args)))
              }, "Send New Code")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.updateMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[17] || (_cache[17] = _createElementVNode("p", null, "Enter your mobile number below.", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-muted" }, "A new verification code will be sent via SMS to the number you enter.", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_vue_tel_input, {
                modelValue: _ctx.mobileInput,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mobileInput) = $event)),
                mode: "international",
                "preferred-countries": ['US','CA','MX'],
                onValidate: _ctx.updateValidation
              }, null, 8, ["modelValue", "onValidate"]),
              (!_ctx.validNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Invalid Number"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-sm",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editMobile && _ctx.editMobile(...args)))
              }, _cache[15] || (_cache[15] = [
                _createTextVNode("Cancel "),
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ])),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm ms-2",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitMobile && _ctx.submitMobile(...args))),
                disabled: !_ctx.validNumber
              }, _cache[16] || (_cache[16] = [
                _createTextVNode("Submit "),
                _createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
              ]), 8, _hoisted_15)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, { active: _ctx.loading }, null, 8, ["active"])
  ], 64))
}